import { render, staticRenderFns } from "./MenuLrPlusHeader.vue?vue&type=template&id=3868c095&"
import script from "./MenuLrPlusHeader.vue?vue&type=script&lang=js&"
export * from "./MenuLrPlusHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports